/* eslint-disable import/no-anonymous-default-export */

// import { alpha, styled } from '@mui/styles';
import { alpha, styled } from '@mui/material/styles';
import {
  AppBar,
  Badge,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Icon,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Switch,
  ToggleButton,
  ToggleButtonGroup,
  Toolbar,
  Tooltip,
  Typography,
  useMediaQuery,
} from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import {
  mainAppBarDimen,
  mainDrawerDimen,
  toPixel,
} from '../styles/dimensions';
import { useMainFrameDispatch, useMainFrameState } from '../MainFrame';
import {
  ACTION_DARK_MODE,
  ACTION_OPEN_MAIN_DRAWER,
  ACTION_SET_APPBAR_JSX,
} from '../constants';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import {
  setAnchorEl,
  setPopoverFrom,
  setTemplate,
} from '../../../redux/features/popoverSlice';
import { useDispatch, useSelector } from 'react-redux';
import { NotificationTemplate } from '../../reusableUiComponent/NotificationTemplate';
import { SECTION_NOTIFICATIONS } from '../../../constants/sections/sectionConstants';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ClearAllRoundedIcon from '@mui/icons-material/ClearAllRounded';
import ClearIcon from '@mui/icons-material/Clear';
import UIButton from 'component/ui/form/UIButton';
import NotificationsBell from './NotificationBell';
import { useLocation, useNavigate } from 'react-router-dom';
import _, { isEmpty } from 'lodash';
import { mainDrawerJson } from '../../MainUIFrame/data/mainDrawerJson';
import { ArrowBack } from '@mui/icons-material';
import { setIsLoggedInAsAdmin } from 'redux/features/currentUserSlice';
import Confirmation from 'component/ui/ConfirmationDialog/ConfirmationDialog';
import { useConfirm } from 'material-ui-confirm';
import AdminManual from "../../../assets/demo/EnlivCred_Admin_Manual.pdf"
import UserManual from "../../../assets/demo/EnlivCred_User_Manual.pdf"


const CustomAppBar = styled(AppBar)(({ theme, isBottom, isRightDrawerOpen }) => ({
  zIndex: isBottom
    ? theme => theme.zIndex.drawer + 1
    : isRightDrawerOpen
      ? theme => theme.zIndex.drawer + 1
      : theme => theme.zIndex.modal + 1,
}));

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  backgroundColor: '#F2F4F7',
  borderRadius: '90px',
  padding: '3px',
  height: '30px',
  width: '126px',
  cursor: 'pointer'
}));

const StyledToggleButton = styled(ToggleButton)(({ theme, isInactive = false, isDark }) => ({
  borderRadius: '90px !important',
  borderColor: 'transparent !important',
  fontSize: '14px',
  textTransform: 'capitalize',
  height: '20px',
  width: '60px',
  fontFamily: "Avenir Next",
  fontWeight: '500',
  color: '#6C757D',
  cursor: 'pointer !important',
  '&.Mui-selected': {
    backgroundColor: isInactive ? 'red' : '#3D2470',
    color: '#fff',
    '&:hover': {
      color: '#000',
    },
  },

  '&:hover': {
    backgroundColor: isDark && '#D9DBDE'
  },
}));

const openMixin = theme => {
  return {
    width: `calc(100% - ${toPixel(mainDrawerDimen.open.width)})`,
    transition: theme?.transitions?.create(['margin', 'width'], {
      easing: theme?.transitions?.easing?.easeOut,
      duration: theme?.transitions?.duration?.enteringScreen,
    }),
  };
};

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '12ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
}));

export default props => {
  //global context
  const {
    isToolbarOpen,
    isDark,
    mainDrawerOpen,
    appBarJsx,
    bottomBarJsx,
    isRightDrawerOpen,
  } = useMainFrameState();
  const dispatch = useMainFrameDispatch();
  //end

  const notificationsList = useSelector(
    state => state?.popover?.notificationsList
  );
  const [alignment, setAlignment] = useState(localStorage.getItem('isLoggedInAsAdmin') === 'false' ? 'user' : 'admin');
  const isAdmin = useSelector(state => state?.currentUser?.isAdmin);
  const theme = useSelector(state => state?.currentUser?.theme);
  const notificationsListSize = notificationsList?.length;
  const Confirmation = useConfirm()

  const { isBottom, isToolbar } = props;

  const reduxDispatch = useDispatch();
  const isMobileResolution = useMediaQuery('(max-width:767px)');
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  const handleChange = async (event, newAlignment) => {
    if (newAlignment !== null) {
      Confirmation({ title: i18n.t('common.ARE_YOU_SURE'), description: alignment === 'user' ? i18n.t(`common.ARE_YOU_SURE_YOU_WANT_TO_SWITCH_TO_ADMIN`) : i18n.t(`common.ARE_YOU_SURE_YOU_WANT_TO_SWITCH_TO_USER`) })
        .then(() => {
          if (newAlignment !== null) {
            try {
              // setToggleLoading(true)
              if (newAlignment === 'admin') {
                reduxDispatch(setIsLoggedInAsAdmin(true))
                localStorage.setItem(`isLoggedInAsAdmin`, true);
              } else {
                reduxDispatch(setIsLoggedInAsAdmin(false))
                localStorage.setItem(`isLoggedInAsAdmin`, false);
              }
              setAlignment(newAlignment);
              navigate('home/dashboard')
            } catch (e) {
              console.error('error: ', e?.message)
            } finally {
              // setToggleLoading(false)
            }
          }
        })
        .catch(() => { })
    }
  };
  const NVAppBar = styled(AppBar, {
    shouldForwardProp: props => true,
  })(props => {
    const { theme } = props;
    return {
      zIndex: isBottom
        ? theme.zIndex.drawer + 1
        : isRightDrawerOpen
          ? theme.zIndex.drawer + 1
          : theme.zIndex.modal + 1,
      overflow: 'hidden',
      height: toPixel(mainAppBarDimen.height),
      width: isMobileResolution
        ? '100%'
        : `calc(100% - ${toPixel(mainDrawerDimen.closed.width)})`,
      backgroundColor: theme.palette.appBarColor,
      // transition: theme.transitions.create(['margin', 'width'], {
      //   easing: theme.transitions.easing.sharp,
      //   duration: theme.transitions.duration.leavingScreen,
      // }),
      ...(isBottom && {
        top: 'auto',
        bottom: 0,
      }),
      ...(mainDrawerOpen && openMixin(theme)),
      // ...(isToolbar && isToolbarOpen && {
      //     marginTop: `${mainAppBarDimen.height}px`,
      //     visibility: 'none'
      // })
    };
  });

  const Menu = () => {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {!mainDrawerOpen && (
          <IconButton
            onClick={() => dispatch({ type: ACTION_OPEN_MAIN_DRAWER })}
          >
            <Icon
              sx={{
                color: theme == 'dark' ? 'white' : 'black',
              }}
            >
              menu
            </Icon>
          </IconButton>
        )}
      </div>
    );
  };

  return (
    <>
      <Box >
        <CustomAppBar
          isBottom={isBottom}
          isRightDrawerOpen={isRightDrawerOpen}
          sx={{
            overflow: 'hidden',
            height: toPixel(mainAppBarDimen.height),
            width: isMobileResolution
              ? '100%'
              : `calc(100% - ${toPixel(mainDrawerDimen.closed.width)})`,
            backgroundColor: theme => theme.palette.appBarColor,
            ...(isBottom && {
              top: 'auto',
              bottom: 0,
            }),
            ...(mainDrawerOpen && openMixin(theme)),
          }}
        >
          <Toolbar className='d-flex justify-content-between' sx={{ marginTop: '-10px', padding: '0px !important' }}>
            <Box
              sx={{ display: 'flex', alignItems: 'center', height: isMobileResolution && '64px', justifyContent: 'space-between' }}
            >
              {isMobileResolution && <Menu />}
              {(!mainDrawerOpen || !isMobileResolution) && (
                <>
                  <div className="ps-3">
                    <AppTitle />
                  </div>
                  {!isBottom && appBarJsx}
                </>
              )}
            </Box>
            <Box style={{fontFamily:'Avenir Next', fontWeight:'600'}} className="d-flex justify-content-between align-items-center">
              {
                isAdmin && alignment === 'admin' ? (
                  <a href={AdminManual} download="Enlivcred_Admin_manual.pdf" style={{ marginRight: '10px', color: '#9472db' }}>
                    {i18n.t('common.ENLIVCRED_ADMIN_MANUAL')}
                  </a>) : (<>
                    <a href={UserManual} download="Enlivcred_User_manual.pdf" style={{ marginRight: '10px', color: '#9472db' }}>
                      {i18n.t('common.ENLIVCRED_USER_MANUAL')}
                    </a>
                  </>)
              }
              {
                isAdmin ? (
                  <StyledToggleButtonGroup color="primary"
                    sx={{ backgroundColor: isDark ? '#2C353D' : '' }}
                    value={alignment}
                    exclusive
                    onChange={handleChange}
                    aria-label="Toggle">
                    <StyledToggleButton isDark={isDark} value="admin">Admin</StyledToggleButton>
                    <StyledToggleButton isDark={isDark} value="user">User</StyledToggleButton>
                  </StyledToggleButtonGroup>

                ) : (
                  <></>
                )
              }
              <NotificationsBell />
            </Box>
          </Toolbar>
        </CustomAppBar>
      </Box>
    </>
  );
};

const AppTitle = () => {
  const location = useLocation();
  const { i18n } = useTranslation();

  const appbarObj = useSelector(state => state?.appbar);
  const pathname = location.pathname;
  const parts = pathname.split('/');
  const filteredParts = parts.filter(part => part !== '');

  const lastWord = filteredParts[filteredParts.length - 1];
  // const mypath = mainDrawerJson.find(obj => obj.link == pathname) || {title: pathname?.replace('/', '_')?.toUpperCase()};
  const isMobileResolution = useMediaQuery('(max-width:767px)');
  const navigate = useNavigate();
  const loading = useSelector(state => state?.appbar?.loading);
  const message = appbarObj?.title ? appbarObj?.title : filteredParts?.[0] === 'staff' ? filteredParts?.find(f => f === 'manage' || f === 'addanewstaffmember')?.length > 0 ? i18n.t(`common.${lastWord?.toUpperCase()}`) : "" : i18n.t(`common.${lastWord?.toUpperCase()}`)

  return (
    <>
      {!loading && (
        <div
          className={`primary b-500 ${isMobileResolution ? 'fs-7' : 'fs-6'} d-flex justify-content-center align-items-center`}
        >
          {appbarObj?.navigateBackTo && (
            <ArrowBack
              sx={{
                marginRight: '10px',
                cursor: 'pointer',
              }}
              onClick={() => navigate(appbarObj?.navigateBackTo)}
            />
          )}
          <Typography sx={{ fontWeight: '600', fontFamily: 'Avenir next' }}>
            {/* {appbarObj?.title || i18n.t(`common.${lastWord?.toUpperCase()}`)} */}
            {message}
          </Typography>
        </div>
      )}
    </>
  );
};
